import founder from '@assets/founders.webp';
import SliderComponent from '@components/shared/CustomSlider';
import Image from 'next/image';

import shivam from '@assets/founders/shivam.webp';
import vikash from '@assets/founders/vikash.webp';
import ravi from '@assets/founders/ravi.webp';
import arshyan from '@assets/founders/arshyan.webp';
import alok from '@assets/founders/alok.webp';

const NoteFromFounders = () => {
  const foundersData = [
    {
      name: 'Shivam Dutta',
      designation: 'Co-Founder & CEO',
      image: shivam,
      education: 'IIT Kharagpur',
    },
    {
      name: 'Vikash Srivastava',
      designation: 'Co-Founder & CTO',
      image: vikash,
      education: 'IIT Kharagpur',
    },
    {
      name: 'Ravi Kumar Gupta',
      designation: 'Co-Founder & CBO',
      image: ravi,
      education: 'IIT Delhi, IIM Lucknow',
    },
    {
      name: 'Arshyan Ahsan',
      designation: 'Co-founder & CGO',
      image: arshyan,
      education: 'IIT Kharagpur',
    },
    {
      name: 'Alok Anand',
      designation: 'Co-founder & COO',
      image: alok,
      education: 'IIT Kharagpur',
    },
  ];

  return (
    <div className="flex flex-col gap-y-[64px] overflow-hidden px-[16px] pt-[40px] pb-[61px] md:py-[96px] md:px-[124px]">
      <div className="flex w-full flex-col gap-y-[20px]">
        <h2 className="font-satoshi-bold text-[36px] leading-none text-[#101828]">
          Meet our Founders
        </h2>
        <p className="font-satoshi-regular text-[20px] leading-[30px] text-gray-11">
          Our founders bring a wealth of expertise from the esteemed halls of India's most
          prestigious institutions, including IIMs and IITs
        </p>
      </div>

      <div className="w-full">
        <SliderComponent
          swiperOptions={{
            breakpoints: {
              320: {
                slidesPerView: 2,
                spaceBetween: 16,
                slidesPerGroup: 1,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 32,
              },
            },
          }}
          buttonStyle={{
            size: 24,
            buttonClass: 'col-span-6 rounded-full',
            leftButton: 'place-self-end',
            rightButton: 'place-self-start',
          }}
        >
          {foundersData.map((item, index) => (
            <FoundersCard key={index} {...item} />
          ))}
        </SliderComponent>
      </div>

      <div className="grid items-center gap-y-[32px] gap-x-[64px] md:grid-cols-12">
        <div className="flex w-full flex-col items-start gap-y-[40px] md:col-span-6">
          <h4 className="text-center font-satoshi-bold text-[36px] leading-none md:text-left">
            Note from our Founders
          </h4>
          <p className="text-justify font-satoshi-regular text-[18px] leading-7 text-gray-400 md:text-left">
            Welcome to AlmaBetter! As founders, we’re excited to share our passion for Data Science
            and Software Engineering with AI with you. Our journey in this ever-evolving field has
            been deeply rewarding, and we are committed to helping you unlock your full potential
            for a high-growth career. Join us on this exciting adventure as we explore the limitless
            possibilities of technology together. Let’s innovate, create, and achieve excellence to
            build the careers of tomorrow!
          </p>
        </div>
        <div className="h-full w-full md:col-span-6">
          <Image
            objectFit="cover"
            src={founder}
            alt="educator"
            className="rounded-2xl"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default NoteFromFounders;

function FoundersCard({ image, name, designation, education }) {
  return (
    <div className="relative flex flex-col items-start gap-y-[18px]">
      <Image
        src={image}
        width={274}
        height={292}
        objectFit="contain"
        loading="lazy"
        className="rounded-xl"
      />

      <div className="flex flex-col items-start gap-y-[4px]">
        <h4 className="font-satoshi-bold text-[18px] leading-7">{name}</h4>
        <div className="flex flex-col items-start gap-y-[2px]">
          <p className="font-satoshi-medium text-[16px] leading-6">{designation}</p>
          <p className="font-satoshi-regular text-[14px] italic leading-5">{education}</p>
        </div>
      </div>
    </div>
  );
}
